import { ResolvedTab, ContentfulPageProductPageV2 } from "../types/ContentfulTypes";
import { TabHeader, useTabsContext } from "@vp/swan";
import React, { useEffect, useRef } from "react";
import { Translations } from "../utils/Translation";
import { tabHeaderTranslations } from "../utils/Tabs";
import { IssuesWrapper } from "@vp/gatsby-pages-issues-tracker-plugin";

export interface ProductPageTabHeaderProps {
  tab: ResolvedTab;
  tabIndex: string;
  locale: string;
  pageData: ContentfulPageProductPageV2;
  selectedTabFocus: boolean;
  setSelectedTabFocus: (focused: boolean) => void;
}

export const TranslatedHeader = (props: ProductPageTabHeaderProps) => {
  const { tab, tabIndex, selectedTabFocus, setSelectedTabFocus } = props;

  const { selectedTabId } = useTabsContext();

  const ref = useRef<HTMLInputElement>(null);

  const tabType = tab?.type ?? tab?.__typename ?? "";

  const translationEntry = Translations.getInstance().getTranslationEntry(
    tabHeaderTranslations[`${tabType}`]
  );

  const onBlur = () => {
    setSelectedTabFocus(false);
  };

  useEffect(() => {
    if (selectedTabId === tabIndex) {
      if (selectedTabFocus) {
        ref.current?.focus({
          preventScroll: true,
        });
      }
    }
  }, [selectedTabFocus]);

  return (
    <React.Fragment>
      {tabType && (
        <IssuesWrapper targetNodes={[translationEntry]} elementName={`${tab.type} Header`}>
          <TabHeader
            key={tabIndex}
            tabId={tabIndex}
            inputProps={{
              //@ts-ignore
              ref: ref,
              onBlur: onBlur,
              "aria-selected": selectedTabId === tabIndex,
            }}
          >
            {translationEntry}
          </TabHeader>
        </IssuesWrapper>
      )}
    </React.Fragment>
  );
};
